import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-76ab84fa.js';
import React, { useState } from 'react';
import 'dayjs';
import moment from 'moment';
import loadable from '@loadable/component';
import { serializeNode } from './wigUtils.js';
import renderHTML from 'react-render-html';
import buildMediaContent from './buildMediaContent.js';
import Viewer, { Worker } from '@phuocng/react-pdf-viewer';
import { getAdaptiveImage } from './imgUtils.js';
import { v4 } from 'uuid';
import 'escape-html';
import 'slate';
import 'react-adaptive-image';
import './md5Utils.js';

require('es6-promise').polyfill();

var ReactPlayer = loadable(function () {
  return import('react-player');
});
var WeducNewsFeed = loadable(function () {
  return import('./weducNewsfeed.js');
});
var WeducCalendar = loadable(function () {
  return import('./weducCalendar.js');
});
var WeducNotices = loadable(function () {
  return import('./weducNotices.js');
});
var WeducFolders = loadable(function () {
  return import('./weducFolders.js');
});
var WeducLogin = loadable(function () {
  return import('./weducLogin.js');
});
var ContactForm = loadable(function () {
  return import('./contactForm.js');
});
var FormViewerPlayer = loadable(function () {
  return import('./FormViewerPlayer-d23e8734.js');
});
var PhotosGallaeryComp = loadable(function () {
  return import('./photosGallery-3be6aeaf.js');
});
var MapWidget = loadable(function () {
  return import('./mapWidget.js');
});
var SmartFeedJobList = loadable(function () {
  return import('./SmartFeedJobList.js');
});
var SmartFeedJobAlerts = loadable(function () {
  return import('./SmartFeedJobAlerts.js');
});
var SavedJobList = loadable(function () {
  return import('./SavedJobList.js');
});
var NovaJobList = loadable(function () {
  return import('./NovaJobList.js');
});
var SmartFeedIndividual = loadable(function () {
  return import('./SmartFeedIndividual.js');
});
var NovaIndividual = loadable(function () {
  return import('./NovaIndividual.js');
});
var OEmbed = loadable(function () {
  return import('./oEmbed-d6b9ff77.js');
});

var renderPage = function renderPage(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.svgLayer.children, props.textLayer.children, props.annotationLayer.children);
};

var FormatFileLocationIcon = function FormatFileLocationIcon(ext) {
  var FileTypeIcon = '';

  if (ext === 'txt') {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file alternate outline icon fal fa-file-alt"
    });
  } else if (ext === 'doc' || ext === 'docx') {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file word outline icon fal fa-file-word"
    });
  } else if (ext === 'rtf') {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file alternate outline icon fal fa-file-alt"
    });
  } else if (ext === 'pdf') {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file pdf outline icon fal fa-file-pdf"
    });
  } else if (ext === 'csv') {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file excel outline icon fal fa-file-excel"
    });
  } else if (ext === 'xls' || ext === 'xlsx') {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file excel outline icon fal fa-file-excel"
    });
  } else if (ext === 'jpg' || ext === 'jpeg') {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file image outline icon fal fa-file-image"
    });
  } else if (ext === 'png') {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file image outline icon fal fa-file-image"
    });
  } else if (ext === 'svg') {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file image outline icon fal fa-file-image"
    });
  } else if (ext === 'zip') {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file archive outline icon fal fa-file-archive"
    });
  } else {
    FileTypeIcon = /*#__PURE__*/React.createElement("span", {
      className: "file outline icon fal fa-file"
    });
  }

  return FileTypeIcon;
};

var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
      wrapper = _ref.wrapper,
      children = _ref.children;
  return condition ? wrapper(children) : children;
};

var WigLoader = function WigLoader(props) {
  var contentDataData = props.contentDataData;
  var contentDataArray = props.contentDataArray;
  var contentDataChild = props.contentDataChild;
  var customDataArray = props.customDataArray;
  var contentMetaData = props.contentMetaData;
  var wigContentArray = [];

  if (customDataArray) {
    wigContentArray = customDataArray;
  } else if (!customDataArray && contentDataData[contentDataArray] && contentDataData[contentDataArray].children && contentDataData[contentDataArray].children[contentDataChild] && contentDataData[contentDataArray].children[contentDataChild].value) {
    wigContentArray = contentDataData[contentDataArray].children[contentDataChild].value;
  }

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2);

  _useState2[0];
  var setNewsfeedWysLoaded = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      vacancyLoading = _useState4[0],
      setVacancyLoading = _useState4[1];

  function convertWigJSON(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return str;
    }

    return JSON.parse(str);
  }

  function RenderWigItem(_ref2) {
    var item = _ref2.item,
        index = _ref2.index,
        props = _ref2.props;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, console.debug('Wig item => ', item), item.type && item.type === 'layout' ? /*#__PURE__*/React.createElement("div", {
      className: "content-layout-wrapper"
    }, item && item.children && item.children.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "content-layout-inner-block"
    }, item.children.map(function (child, index) {
      return /*#__PURE__*/React.createElement(RenderWigItem, {
        item: child,
        index: index
      });
    }))) : item.type && item.type === 'layout-cell' ? /*#__PURE__*/React.createElement("div", {
      className: "content-layout-inner-block-child",
      style: {
        width: item.width ? item.width + '%' : '50%'
      }
    }, item.children.map(function (child, index) {
      return /*#__PURE__*/React.createElement(RenderWigItem, {
        item: child,
        index: index
      });
    })) : item.type && item.type === 'form-loader' ? /*#__PURE__*/React.createElement("div", {
      className: "form-wig-loader-wrap",
      id: 'form-loader' + v4()
    }, /*#__PURE__*/React.createElement(FormViewerPlayer, {
      id: item.formLoaderID,
      type: item.formType || 'form',
      siteId: props.accroPressSiteID,
      userId: props.userID || v4(),
      sessionId: props.sessionId || v4()
    })) : item.type && item.type === 'link' && item.display === 'embed' ? /*#__PURE__*/React.createElement(OEmbed, {
      url: item.url
    }) : item.type && item.type === 'oembed' ? /*#__PURE__*/React.createElement(OEmbed, {
      url: item.url
    }) : item.type && item.type === 'contact-form' ? /*#__PURE__*/React.createElement("div", {
      className: "contact-form-wrap",
      id: 'contact-form' + v4()
    }, /*#__PURE__*/React.createElement(ContactForm, {
      weducAPIURL: props.weducAPIURL,
      AccroPressProdEndpoint: props.AccroPressProdEndpoint,
      AccroPressLocalEndpoint: props.AccroPressLocalEndpoint,
      integratorID: props.integratorID,
      integratorAccessToken: props.integratorAccessToken
    })) : item.type && item.type === 'gallery-list' ? /*#__PURE__*/React.createElement("div", {
      className: "image-gallery-wrap image-gallery-list-wrap",
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/React.createElement("section", {
      className: "ap-wig-gallery"
    }, /*#__PURE__*/React.createElement(PhotosGallaeryComp, {
      photos: item.children,
      type: 'gallery-list' + v4()
    }))) : item.type && item.type === 'image-gallery' ? /*#__PURE__*/React.createElement("div", {
      className: "image-gallery-wrap",
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/React.createElement("section", {
      className: "ap-wig-gallery"
    }, /*#__PURE__*/React.createElement(PhotosGallaeryComp, {
      photos: item.images
    }))) : item.type && item.type === 'image-gallery-ap' ? /*#__PURE__*/React.createElement("div", {
      className: "image-gallery-wrap",
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/React.createElement("section", {
      className: "ap-wig-gallery"
    }, item && item.images && item.images.length > 0 && /*#__PURE__*/React.createElement("ol", null, item.images.map(function (image, index) {
      return /*#__PURE__*/React.createElement("li", {
        key: index,
        index: index,
        "data-model-image": image.url,
        style: {
          backgroundImage: "url(".concat(image.url, ")")
        }
      });
    })))) : item.type && item.type === 'img' && item.url.indexOf('.pdf') != -1 ? /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Worker, {
      workerUrl: "https://unpkg.com/pdfjs-dist@2.5.207/build/pdf.worker.min.js"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        height: '750px'
      }
    }, /*#__PURE__*/React.createElement(Viewer, {
      fileUrl: item.url,
      renderPage: renderPage
    })))) : item.type && item.type === 'image' && item.url.indexOf('.pdf') != -1 ? /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Worker, {
      workerUrl: "https://unpkg.com/pdfjs-dist@2.5.207/build/pdf.worker.min.js"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        height: '750px'
      }
    }, /*#__PURE__*/React.createElement(Viewer, {
      fileUrl: item.url,
      renderPage: renderPage
    })))) : item.type && (item.type === 'image' || item.type === 'img') ? /*#__PURE__*/React.createElement("div", {
      className: "image-position-".concat(item.position, " ").concat(item.data && item.data.classname ? item.data.classname : item.className ? item.className : item.classname ? item.classname : '')
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%',
        maxWidth: item.resizedWidth || '100%'
      }
    }, /*#__PURE__*/React.createElement(ConditionalWrapper, {
      condition: item.link || (item.data && item.data.link ? item.data.link : false),
      wrapper: function wrapper(children) {
        return /*#__PURE__*/React.createElement("a", {
          href: item.link || (item.data && item.data.link ? item.data.link : false)
        }, children);
      }
    }, (item.width || item.height) && item.url.includes('https://cdn2.accropress.com') ? getAdaptiveImage(item.url, item.isBackgroundImage || false, "wig-image ".concat(item.data && item.data.classname ? item.data.classname : item.className ? item.className : item.classname ? item.classname : ''), item.alt || 'An image', item.width ? parseInt(item.width.replace(/\D/g, ''), 10) : 'auto', item.height ? parseInt(item.height.replace(/\D/g, ''), 10) : 'auto', item.quality ? parseInt(item.quality.replace(/\D/g, ''), 10) : null, item.auto, item.crop, item.focalcrop) : /*#__PURE__*/React.createElement("img", {
      width: item.width ? parseInt(item.width.replace(/\D/g, ''), 10) : 'auto',
      height: item.height ? parseInt(item.height.replace(/\D/g, ''), 10) : 'auto',
      src: item.url,
      alt: item.alt || 'An image'
    })))) : item.type && item.type === 'file' && item.extension === 'pdf' ? /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Worker, {
      workerUrl: "https://unpkg.com/pdfjs-dist@2.5.207/build/pdf.worker.min.js"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        height: '750px'
      }
    }, /*#__PURE__*/React.createElement(Viewer, {
      fileUrl: item.url,
      renderPage: renderPage
    })))) : item.type && item.type === 'video' ? /*#__PURE__*/React.createElement("div", {
      className: "video-wrapper",
      style: {
        width: '100%',
        maxWidth: item.resizedWidth || '100%'
      }
    }, /*#__PURE__*/React.createElement(ReactPlayer, {
      width: "100%",
      height: "450px",
      url: item.url,
      light: true,
      controls: true,
      volume: undefined
    })) : item.type && item.type === 'smartfeed-joblist' ? /*#__PURE__*/React.createElement(SmartFeedJobList, {
      siteConfig: props.siteConfig || item.siteRecord,
      vacancyLoading: vacancyLoading,
      apiKey: props.apiKey || item.siteRecord ? item.siteRecord.smartfeedID : '',
      gdprKey: props.gdprKey || item.siteRecord ? item.siteRecord.smartfeedID : '',
      group: props.group || false,
      CompanyGroupName: props.CompanyGroupName || item.siteRecord ? item.siteRecord.name : '',
      OptInLink: props.OptInLink || item.siteRecord && item.siteRecord.OptInLink ? item.siteRecord.OptInLink : '',
      UnsubscribeLink: props.UnsubscribeLink || item.siteRecord && item.siteRecord.UnsubscribeLink ? item.siteRecord.UnsubscribeLink : '',
      VacancyPageBaseURL: props.VacancyPageBaseURL || item.siteRecord && item.siteRecord.careersPageVacancyURL ? item.siteRecord.careersPageVacancyURL : '',
      ReturnToSearchURL: props.ReturnToSearchURL || item.siteRecord && item.siteRecord.careersPageURL ? item.siteRecord.careersPageURL : '',
      location: props.location || item.siteRecord ? item.siteRecord.location : true,
      region: props.region || item.siteRecord ? item.siteRecord.region : true,
      category: props.category || item.siteRecord ? item.siteRecord.category : true,
      industry: props.industry || item.siteRecord ? item.siteRecord.industry : true,
      jobType: props.jobType || item.siteRecord ? item.siteRecord.jobType : true,
      jobTime: props.jobTime || item.siteRecord ? item.siteRecord.jobTime : true,
      defaultVacancyTitle: props.defaultVacancyTitle || item.defaultVacancyTitle,
      defaultSortBySelection: props.defaultSortBySelection || item.defaultSortBySelection,
      defaultSortByDirSelection: props.defaultSortByDirSelection || item.defaultSortByDirSelection,
      defaultViewBySelection: props.defaultViewBySelection || item.defaultViewBySelection,
      locationDisplay: props.locationDisplay || item.locationDisplay,
      regionDisplay: props.regionDisplay || item.regionDisplay,
      categoryDisplay: props.categoryDisplay || item.categoryDisplay,
      industryDisplay: props.industryDisplay || item.industryDisplay,
      jobTypeDisplay: props.jobTypeDisplay || item.jobTypeDisplay,
      jobTimeDisplay: props.jobTimeDisplay || item.jobTimeDisplay,
      numberOfVacanciesDisplay: props.numberOfVacanciesDisplay || item.numberOfVacanciesDisplay,
      availableForRemoteWorkersDisplay: props.availableForRemoteWorkersDisplay || item.availableForRemoteWorkersDisplay,
      postingDateDisplay: props.postingDateDisplay || item.postingDateDisplay,
      expiryDateDisplay: props.expiryDateDisplay || item.expiryDateDisplay,
      updatedDateDisplay: props.updatedDateDisplay || item.updatedDateDisplay,
      referenceDisplay: props.referenceDisplay || item.referenceDisplay,
      summaryDisplay: props.summaryDisplay || item.summaryDisplay,
      benefitDisplay: props.benefitDisplay || item.benefitDisplay,
      shareButtonsDisplay: props.shareButtonsDisplay || item.shareButtonsDisplay,
      saveJobDisplay: props.saveJobDisplay || item.saveJobDisplay,
      mapDisplay: props.mapDisplay || item.mapDisplay,
      contentDataData: props.contentDataData || [],
      setVacancyLoading: setVacancyLoading,
      smartfeedCompanyData: {},
      trackEvent: null
    }) : item.type && item.type === 'smartfeed-jobdetails' ? /*#__PURE__*/React.createElement(SmartFeedIndividual, {
      siteConfig: props.siteConfig || item.siteRecord,
      vacancyLoading: vacancyLoading,
      apiKey: props.apiKey || item.siteRecord ? item.siteRecord.smartfeedID : '',
      gdprKey: props.gdprKey || item.siteRecord ? item.siteRecord.smartfeedID : '',
      group: props.group || false,
      CompanyGroupName: props.CompanyGroupName || item.siteRecord ? item.siteRecord.name : '',
      OptInLink: props.OptInLink || item.siteRecord && item.siteRecord.OptInLink ? item.siteRecord.OptInLink : '',
      UnsubscribeLink: props.UnsubscribeLink || item.siteRecord && item.siteRecord.UnsubscribeLink ? item.siteRecord.UnsubscribeLink : '',
      VacancyPageBaseURL: props.VacancyPageBaseURL || item.siteRecord && item.siteRecord.careersPageVacancyURL ? item.siteRecord.careersPageVacancyURL : '',
      ReturnToSearchURL: props.ReturnToSearchURL || item.siteRecord && item.siteRecord.careersPageURL ? item.siteRecord.careersPageURL : '',
      location: props.location || item.siteRecord ? item.siteRecord.location : true,
      region: props.region || item.siteRecord ? item.siteRecord.region : true,
      category: props.category || item.siteRecord ? item.siteRecord.category : true,
      industry: props.industry || item.siteRecord ? item.siteRecord.industry : true,
      jobType: props.jobType || item.siteRecord ? item.siteRecord.jobType : true,
      jobTime: props.jobTime || item.siteRecord ? item.siteRecord.jobTime : true,
      defaultVacancyTitle: props.defaultVacancyTitle || item.defaultVacancyTitle,
      defaultSortBySelection: props.defaultSortBySelection || item.defaultSortBySelection,
      defaultSortByDirSelection: props.defaultSortByDirSelection || item.defaultSortByDirSelection,
      defaultViewBySelection: props.defaultViewBySelection || item.defaultViewBySelection,
      locationDisplay: props.locationDisplay || item.locationDisplay,
      regionDisplay: props.regionDisplay || item.regionDisplay,
      categoryDisplay: props.categoryDisplay || item.categoryDisplay,
      industryDisplay: props.industryDisplay || item.industryDisplay,
      jobTypeDisplay: props.jobTypeDisplay || item.jobTypeDisplay,
      jobTimeDisplay: props.jobTimeDisplay || item.jobTimeDisplay,
      numberOfVacanciesDisplay: props.numberOfVacanciesDisplay || item.numberOfVacanciesDisplay,
      availableForRemoteWorkersDisplay: props.availableForRemoteWorkersDisplay || item.availableForRemoteWorkersDisplay,
      postingDateDisplay: props.postingDateDisplay || item.postingDateDisplay,
      expiryDateDisplay: props.expiryDateDisplay || item.expiryDateDisplay,
      updatedDateDisplay: props.updatedDateDisplay || item.updatedDateDisplay,
      referenceDisplay: props.referenceDisplay || item.referenceDisplay,
      summaryDisplay: props.summaryDisplay || item.summaryDisplay,
      benefitDisplay: props.benefitDisplay || item.benefitDisplay,
      shareButtonsDisplay: props.shareButtonsDisplay || item.shareButtonsDisplay,
      saveJobDisplay: props.saveJobDisplay || item.saveJobDisplay,
      mapDisplay: props.mapDisplay || item.mapDisplay,
      contentDataData: props.contentDataData || [],
      setVacancyLoading: setVacancyLoading,
      smartfeedCompanyData: {},
      trackEvent: null
    }) : item.type && item.type === 'smartfeed-jobalerts' ? /*#__PURE__*/React.createElement(SmartFeedJobAlerts, {
      siteConfig: props.siteConfig || item.siteRecord,
      vacancyLoading: vacancyLoading,
      apiKey: props.apiKey || item.siteRecord ? item.siteRecord.smartfeedID : '',
      gdprKey: props.gdprKey || item.siteRecord ? item.siteRecord.smartfeedID : '',
      group: props.group || false,
      CompanyGroupName: props.CompanyGroupName || item.siteRecord ? item.siteRecord.name : '',
      OptInLink: props.OptInLink || item.siteRecord && item.siteRecord.OptInLink ? item.siteRecord.OptInLink : '',
      UnsubscribeLink: props.UnsubscribeLink || item.siteRecord && item.siteRecord.UnsubscribeLink ? item.siteRecord.UnsubscribeLink : '',
      VacancyPageBaseURL: props.VacancyPageBaseURL || item.siteRecord && item.siteRecord.careersPageVacancyURL ? item.siteRecord.careersPageVacancyURL : '',
      ReturnToSearchURL: props.ReturnToSearchURL || item.siteRecord && item.siteRecord.careersPageURL ? item.siteRecord.careersPageURL : '',
      location: props.location || item.siteRecord ? item.siteRecord.location : true,
      region: props.region || item.siteRecord ? item.siteRecord.region : true,
      category: props.category || item.siteRecord ? item.siteRecord.category : true,
      industry: props.industry || item.siteRecord ? item.siteRecord.industry : true,
      jobType: props.jobType || item.siteRecord ? item.siteRecord.jobType : true,
      jobTime: props.jobTime || item.siteRecord ? item.siteRecord.jobTime : true,
      defaultVacancyTitle: props.defaultVacancyTitle || item.defaultVacancyTitle,
      defaultSortBySelection: props.defaultSortBySelection || item.defaultSortBySelection,
      defaultSortByDirSelection: props.defaultSortByDirSelection || item.defaultSortByDirSelection,
      defaultViewBySelection: props.defaultViewBySelection || item.defaultViewBySelection,
      locationDisplay: props.locationDisplay || item.locationDisplay,
      regionDisplay: props.regionDisplay || item.regionDisplay,
      categoryDisplay: props.categoryDisplay || item.categoryDisplay,
      industryDisplay: props.industryDisplay || item.industryDisplay,
      jobTypeDisplay: props.jobTypeDisplay || item.jobTypeDisplay,
      jobTimeDisplay: props.jobTimeDisplay || item.jobTimeDisplay,
      numberOfVacanciesDisplay: props.numberOfVacanciesDisplay || item.numberOfVacanciesDisplay,
      availableForRemoteWorkersDisplay: props.availableForRemoteWorkersDisplay || item.availableForRemoteWorkersDisplay,
      postingDateDisplay: props.postingDateDisplay || item.postingDateDisplay,
      expiryDateDisplay: props.expiryDateDisplay || item.expiryDateDisplay,
      updatedDateDisplay: props.updatedDateDisplay || item.updatedDateDisplay,
      referenceDisplay: props.referenceDisplay || item.referenceDisplay,
      summaryDisplay: props.summaryDisplay || item.summaryDisplay,
      benefitDisplay: props.benefitDisplay || item.benefitDisplay,
      shareButtonsDisplay: props.shareButtonsDisplay || item.shareButtonsDisplay,
      saveJobDisplay: props.saveJobDisplay || item.saveJobDisplay,
      mapDisplay: props.mapDisplay || item.mapDisplay,
      contentDataData: props.contentDataData || [],
      setVacancyLoading: setVacancyLoading,
      smartfeedCompanyData: {},
      trackEvent: null
    }) : item.type && item.type === 'smartfeed-savedjoblist' ? /*#__PURE__*/React.createElement(SavedJobList, {
      siteConfig: props.siteConfig || item.siteRecord,
      vacancyLoading: vacancyLoading,
      apiKey: props.apiKey || item.siteRecord ? item.siteRecord.smartfeedID : '',
      gdprKey: props.gdprKey || item.siteRecord ? item.siteRecord.smartfeedID : '',
      group: props.group || false,
      CompanyGroupName: props.CompanyGroupName || item.siteRecord ? item.siteRecord.name : '',
      OptInLink: props.OptInLink || item.siteRecord && item.siteRecord.OptInLink ? item.siteRecord.OptInLink : '',
      UnsubscribeLink: props.UnsubscribeLink || item.siteRecord && item.siteRecord.UnsubscribeLink ? item.siteRecord.UnsubscribeLink : '',
      VacancyPageBaseURL: props.VacancyPageBaseURL || item.siteRecord && item.siteRecord.careersPageVacancyURL ? item.siteRecord.careersPageVacancyURL : '',
      ReturnToSearchURL: props.ReturnToSearchURL || item.siteRecord && item.siteRecord.careersPageURL ? item.siteRecord.careersPageURL : '',
      location: props.location || item.siteRecord ? item.siteRecord.location : true,
      region: props.region || item.siteRecord ? item.siteRecord.region : true,
      category: props.category || item.siteRecord ? item.siteRecord.category : true,
      industry: props.industry || item.siteRecord ? item.siteRecord.industry : true,
      jobType: props.jobType || item.siteRecord ? item.siteRecord.jobType : true,
      jobTime: props.jobTime || item.siteRecord ? item.siteRecord.jobTime : true,
      defaultVacancyTitle: props.defaultVacancyTitle || item.defaultVacancyTitle,
      defaultSortBySelection: props.defaultSortBySelection || item.defaultSortBySelection,
      defaultSortByDirSelection: props.defaultSortByDirSelection || item.defaultSortByDirSelection,
      defaultViewBySelection: props.defaultViewBySelection || item.defaultViewBySelection,
      locationDisplay: props.locationDisplay || item.locationDisplay,
      regionDisplay: props.regionDisplay || item.regionDisplay,
      categoryDisplay: props.categoryDisplay || item.categoryDisplay,
      industryDisplay: props.industryDisplay || item.industryDisplay,
      jobTypeDisplay: props.jobTypeDisplay || item.jobTypeDisplay,
      jobTimeDisplay: props.jobTimeDisplay || item.jobTimeDisplay,
      numberOfVacanciesDisplay: props.numberOfVacanciesDisplay || item.numberOfVacanciesDisplay,
      availableForRemoteWorkersDisplay: props.availableForRemoteWorkersDisplay || item.availableForRemoteWorkersDisplay,
      postingDateDisplay: props.postingDateDisplay || item.postingDateDisplay,
      expiryDateDisplay: props.expiryDateDisplay || item.expiryDateDisplay,
      updatedDateDisplay: props.updatedDateDisplay || item.updatedDateDisplay,
      referenceDisplay: props.referenceDisplay || item.referenceDisplay,
      summaryDisplay: props.summaryDisplay || item.summaryDisplay,
      benefitDisplay: props.benefitDisplay || item.benefitDisplay,
      shareButtonsDisplay: props.shareButtonsDisplay || item.shareButtonsDisplay,
      saveJobDisplay: props.saveJobDisplay || item.saveJobDisplay,
      mapDisplay: props.mapDisplay || item.mapDisplay,
      contentDataData: props.contentDataData || [],
      setVacancyLoading: setVacancyLoading,
      smartfeedCompanyData: {},
      trackEvent: null
    }) : item.type && item.type === 'nova-joblist' ? /*#__PURE__*/React.createElement(NovaJobList, {
      siteConfig: props.siteConfig || item.siteRecord,
      vacancyLoading: vacancyLoading,
      apiKey: props.apiKey || item.siteRecord ? item.siteRecord.novaSiteID : '',
      gdprKey: props.gdprKey || item.siteRecord ? item.siteRecord.novaSiteID : '',
      group: props.group || false,
      CompanyGroupName: props.CompanyGroupName || item.siteRecord ? item.siteRecord.name : '',
      OptInLink: props.OptInLink || item.siteRecord && item.siteRecord.OptInLink ? item.siteRecord.OptInLink : '',
      UnsubscribeLink: props.UnsubscribeLink || item.siteRecord && item.siteRecord.UnsubscribeLink ? item.siteRecord.UnsubscribeLink : '',
      VacancyPageBaseURL: props.VacancyPageBaseURL || item.siteRecord && item.siteRecord.careersPageVacancyURL ? item.siteRecord.careersPageVacancyURL : '',
      ReturnToSearchURL: props.ReturnToSearchURL || item.siteRecord && item.siteRecord.careersPageURL ? item.siteRecord.careersPageURL : '',
      location: props.location || item.siteRecord ? item.siteRecord.location : true,
      region: props.region || item.siteRecord ? item.siteRecord.region : true,
      category: props.category || item.siteRecord ? item.siteRecord.category : true,
      industry: props.industry || item.siteRecord ? item.siteRecord.industry : true,
      jobType: props.jobType || item.siteRecord ? item.siteRecord.jobType : true,
      jobTime: props.jobTime || item.siteRecord ? item.siteRecord.jobTime : true,
      defaultVacancyTitle: props.defaultVacancyTitle || item.defaultVacancyTitle,
      defaultSortBySelection: props.defaultSortBySelection || item.defaultSortBySelection,
      defaultSortByDirSelection: props.defaultSortByDirSelection || item.defaultSortByDirSelection,
      defaultViewBySelection: props.defaultViewBySelection || item.defaultViewBySelection,
      locationDisplay: props.locationDisplay || item.locationDisplay,
      regionDisplay: props.regionDisplay || item.regionDisplay,
      categoryDisplay: props.categoryDisplay || item.categoryDisplay,
      industryDisplay: props.industryDisplay || item.industryDisplay,
      jobTypeDisplay: props.jobTypeDisplay || item.jobTypeDisplay,
      jobTimeDisplay: props.jobTimeDisplay || item.jobTimeDisplay,
      numberOfVacanciesDisplay: props.numberOfVacanciesDisplay || item.numberOfVacanciesDisplay,
      availableForRemoteWorkersDisplay: props.availableForRemoteWorkersDisplay || item.availableForRemoteWorkersDisplay,
      postingDateDisplay: props.postingDateDisplay || item.postingDateDisplay,
      expiryDateDisplay: props.expiryDateDisplay || item.expiryDateDisplay,
      updatedDateDisplay: props.updatedDateDisplay || item.updatedDateDisplay,
      referenceDisplay: props.referenceDisplay || item.referenceDisplay,
      summaryDisplay: props.summaryDisplay || item.summaryDisplay,
      benefitDisplay: props.benefitDisplay || item.benefitDisplay,
      shareButtonsDisplay: props.shareButtonsDisplay || item.shareButtonsDisplay,
      saveJobDisplay: props.saveJobDisplay || item.saveJobDisplay,
      mapDisplay: props.mapDisplay || item.mapDisplay,
      contentDataData: props.contentDataData || [],
      setVacancyLoading: setVacancyLoading,
      smartfeedCompanyData: {},
      trackEvent: null
    }) : item.type && item.type === 'nova-jobdetails' ? /*#__PURE__*/React.createElement(NovaIndividual, {
      siteConfig: props.siteConfig || item.siteRecord,
      vacancyLoading: vacancyLoading,
      apiKey: props.apiKey || item.siteRecord ? item.siteRecord.novaSiteID : '',
      gdprKey: props.gdprKey || item.siteRecord ? item.siteRecord.novaSiteID : '',
      group: props.group || false,
      CompanyGroupName: props.CompanyGroupName || item.siteRecord ? item.siteRecord.name : '',
      OptInLink: props.OptInLink || item.siteRecord && item.siteRecord.OptInLink ? item.siteRecord.OptInLink : '',
      UnsubscribeLink: props.UnsubscribeLink || item.siteRecord && item.siteRecord.UnsubscribeLink ? item.siteRecord.UnsubscribeLink : '',
      VacancyPageBaseURL: props.VacancyPageBaseURL || item.siteRecord && item.siteRecord.careersPageVacancyURL ? item.siteRecord.careersPageVacancyURL : '',
      ReturnToSearchURL: props.ReturnToSearchURL || item.siteRecord && item.siteRecord.careersPageURL ? item.siteRecord.careersPageURL : '',
      location: props.location || item.siteRecord ? item.siteRecord.location : true,
      region: props.region || item.siteRecord ? item.siteRecord.region : true,
      category: props.category || item.siteRecord ? item.siteRecord.category : true,
      industry: props.industry || item.siteRecord ? item.siteRecord.industry : true,
      jobType: props.jobType || item.siteRecord ? item.siteRecord.jobType : true,
      jobTime: props.jobTime || item.siteRecord ? item.siteRecord.jobTime : true,
      defaultVacancyTitle: props.defaultVacancyTitle || item.defaultVacancyTitle,
      defaultSortBySelection: props.defaultSortBySelection || item.defaultSortBySelection,
      defaultSortByDirSelection: props.defaultSortByDirSelection || item.defaultSortByDirSelection,
      defaultViewBySelection: props.defaultViewBySelection || item.defaultViewBySelection,
      locationDisplay: props.locationDisplay || item.locationDisplay,
      regionDisplay: props.regionDisplay || item.regionDisplay,
      categoryDisplay: props.categoryDisplay || item.categoryDisplay,
      industryDisplay: props.industryDisplay || item.industryDisplay,
      jobTypeDisplay: props.jobTypeDisplay || item.jobTypeDisplay,
      jobTimeDisplay: props.jobTimeDisplay || item.jobTimeDisplay,
      numberOfVacanciesDisplay: props.numberOfVacanciesDisplay || item.numberOfVacanciesDisplay,
      availableForRemoteWorkersDisplay: props.availableForRemoteWorkersDisplay || item.availableForRemoteWorkersDisplay,
      postingDateDisplay: props.postingDateDisplay || item.postingDateDisplay,
      expiryDateDisplay: props.expiryDateDisplay || item.expiryDateDisplay,
      updatedDateDisplay: props.updatedDateDisplay || item.updatedDateDisplay,
      referenceDisplay: props.referenceDisplay || item.referenceDisplay,
      summaryDisplay: props.summaryDisplay || item.summaryDisplay,
      benefitDisplay: props.benefitDisplay || item.benefitDisplay,
      shareButtonsDisplay: props.shareButtonsDisplay || item.shareButtonsDisplay,
      saveJobDisplay: props.saveJobDisplay || item.saveJobDisplay,
      mapDisplay: props.mapDisplay || item.mapDisplay,
      contentDataData: props.contentDataData || [],
      setVacancyLoading: setVacancyLoading,
      smartfeedCompanyData: {},
      trackEvent: null
    }) : item.type && item.type === 'map' ? /*#__PURE__*/React.createElement("div", {
      className: "wig-map-wrap"
    }, /*#__PURE__*/React.createElement(MapWidget, {
      latitude: item.latitude,
      longitude: item.longitude,
      zoom: item.zoom,
      pitch: item.pitch,
      bearing: item.bearing,
      scrollZoom: item.scrollZoom,
      pitchWithRotate: item.pitchWithRotate,
      dragRotate: item.dragRotate
    })) : item.type && (item.type === 'weduc-widget-newsfeed' || item.subtype === 'weduc-widget-newsfeed' || item.template === 'weduc-widget-newsfeed') ? /*#__PURE__*/React.createElement("div", {
      className: 'weducWidgetDisplay_true'
    }, /*#__PURE__*/React.createElement(WeducNewsFeed, {
      weducAPIURL: props.weducAPIURL,
      limit: 5,
      name: props.weducWebsitesID || '',
      container: props.weducContainer || item.weducComponentID || '',
      pagination: true,
      loadedEvent: setNewsfeedWysLoaded,
      html: function NewsFeedTemplate(props) {
        console.debug('NewsFeedTemplate', props);
        return /*#__PURE__*/React.createElement("div", {
          className: "newsFeedItem"
        }, /*#__PURE__*/React.createElement("span", {
          className: "newsFeedItem_Date"
        }, moment(props.data.createdAt).format('LL')), /*#__PURE__*/React.createElement("div", {
          className: "newsFeedItem_Item",
          dangerouslySetInnerHTML: {
            __html: props.data.contentHtml
          }
        }), props.data.attachment && props.data.attachment.length > 0 && /*#__PURE__*/React.createElement("ul", {
          className: "newsFeedItem_Item_Attachements"
        }, props.data.attachment.map(function (attachment) {
          return /*#__PURE__*/React.createElement("li", {
            className: "newsFeedItem_Item_Attachements_Attachement"
          }, /*#__PURE__*/React.createElement("a", {
            href: attachment.external_url,
            title: attachment.title,
            target: "_blank",
            rel: "noopener noreferer"
          }, attachment.title));
        })), /*#__PURE__*/React.createElement("div", {
          className: "newsFeedItem_Item_PostMeta",
          dangerouslySetInnerHTML: {
            __html: buildMediaContent(props.data.postType)
          }
        }));
      },
      route: contentMetaData.slug
    })) : item.type && (item.type === 'weduc-widget-calendar' || item.subtype === 'weduc-widget-calendar' || item.template === 'weduc-widget-calendar') ? /*#__PURE__*/React.createElement("div", {
      className: 'weducWidgetDisplay_true'
    }, /*#__PURE__*/React.createElement(WeducCalendar, {
      weducAPIURL: props.weducAPIURL,
      name: props.weducWebsitesID || '',
      container: props.weducContainer || props.weducContainerID || item.weducComponentID,
      route: contentMetaData.slug,
      loadedEvent: setNewsfeedWysLoaded
    })) : item.type && (item.type === 'weduc-widget-login' || item.subtype === 'weduc-widget-login' || item.template === 'weduc-widget-login') ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WeducLogin, {
      entity: item.weducEntity,
      localeCode: item.localeCode
    })) : item.type && (item.type === 'weduc-widget-notices' || item.subtype === 'weduc-widget-notices' || item.template === 'weduc-widget-notices') ? /*#__PURE__*/React.createElement("div", {
      className: 'weducWidgetDisplay_true'
    }, /*#__PURE__*/React.createElement(WeducNotices, {
      weducAPIURL: props.weducAPIURL,
      delay: 5,
      limit: 5,
      name: props.weducWebsitesID || '',
      container: props.weducContainer || props.weducContainerID || item.weducComponentID,
      html: function NewsFeedTemplate(props) {
        return /*#__PURE__*/React.createElement("div", {
          className: "noticesItem"
        }, /*#__PURE__*/React.createElement("span", {
          className: "noticesContent"
        }, props.data.attachment && props.data.attachment[0] && props.data.attachment[0].external_url ? /*#__PURE__*/React.createElement("a", {
          href: props.data.attachment[0].external_url,
          title: props.data.attachment[0].title,
          target: "_blank"
        }, /*#__PURE__*/React.createElement("strong", {
          className: "title"
        }, props.data.title.replace(/&nbsp;/g, '').replace(/&pound;/g, '£')), /*#__PURE__*/React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: props.data.message
          }
        })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", {
          className: "title"
        }, props.data.title.replace(/&nbsp;/g, '').replace(/&pound;/g, '£')), /*#__PURE__*/React.createElement("div", {
          className: "content",
          dangerouslySetInnerHTML: {
            __html: props.data.message
          }
        }))));
      },
      loadedEvent: setNewsfeedWysLoaded
    })) : item.type && (item.type === 'weduc-widget-folders' || item.subtype === 'weduc-widget-folders' || item.template === 'weduc-widget-folders') ? /*#__PURE__*/React.createElement("div", {
      className: 'weducWidgetDisplay_true'
    }, /*#__PURE__*/React.createElement(WeducFolders, {
      weducAPIURL: props.weducAPIURL,
      name: props.weducWebsitesID || '',
      container: props.weducContainer || props.weducContainerID || item.weducComponentID,
      entity: props.weducEntity,
      folderID: item.weducComponentID,
      sort: item.sort,
      html: function NewsFeedTemplate(props) {
        return /*#__PURE__*/React.createElement("div", {
          className: "foldersItem"
        }, /*#__PURE__*/React.createElement("a", {
          className: "ap-file-component",
          target: "_blank",
          href: props.data.external_url
        }, /*#__PURE__*/React.createElement("div", {
          className: "ap-file-component-extension ap-file-component-extension-".concat(props.data.external_url.split('.').pop())
        }, /*#__PURE__*/React.createElement("span", {
          className: "file-component-extension-icon"
        }, FormatFileLocationIcon(props.data.external_url.split('.').pop())), /*#__PURE__*/React.createElement("span", {
          style: {
            display: 'none'
          },
          className: "file-component-extension-text"
        }, props.data.external_url.split('.').pop())), /*#__PURE__*/React.createElement("div", {
          className: "ap-file-component-filename"
        }, props.data.title)));
      },
      loadedEvent: setNewsfeedWysLoaded
    })) : renderHTML(serializeNode(item)));
  }

  if (contentDataData && contentMetaData && contentDataArray && contentDataChild) {
    return /*#__PURE__*/React.createElement("div", {
      className: "wig-contents-wrap"
    }, wigContentArray && wigContentArray !== [] ? /*#__PURE__*/React.createElement(React.Fragment, null, convertWigJSON(wigContentArray) && Array.isArray(convertWigJSON(wigContentArray)) && convertWigJSON(wigContentArray).length >= 0 && /*#__PURE__*/React.createElement(React.Fragment, null, convertWigJSON(wigContentArray).map(function (item, i) {
      return /*#__PURE__*/React.createElement(RenderWigItem, {
        item: item,
        index: i,
        props: props
      });
    }))) : /*#__PURE__*/React.createElement("p", null, "No content found."));
  } else {
    return /*#__PURE__*/React.createElement("p", null, "Error: Content meta was supplied incorrectly to WigLoader");
  }
};

export default WigLoader;